/* eslint-disable */
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import MiscellaneousFeesDashboardContainer from './containers/MiscellaneousFeesDashboardContainer';
import * as actions from './action';
import * as c from './constant';

const DashboardContainer = ({ totalStats, getTotalStats }) => {
  const miscellaneousFees = () => {
    const data = _.get(totalStats, 'item.TYPES.MISCELLANEOUS FEES.total_per_status');


    return {
      label: 'Miscellaneous Fees',
      total: _.get(totalStats, 'item.TYPES.MISCELLANEOUS FEES.total', 0),
      list: [
        {
          label: 'Waiting for Payment',
          value: _.get(data, 'WAITING FOR PAYMENT', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Pending',
          value: _.get(data, 'PENDING', 0),
          borderClassName: 'checking',
        },
        {
          label: 'Paid',
          value: _.get(data, 'PAID', 0),
          borderClassName: 'paid',
        },
        {
          label: 'Expired Reference Number',
          value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0),
          borderClassName: 'received',
        },
      ],
    };
  };

  useEffect(() => {
    getTotalStats();
  }, []);

  return (
    <div className="container-fluid mb-3">
      <div className="row">
        <div className="col-4 pl-0">
          <DashboardListCard data={miscellaneousFees()} />
        </div>
        <div className="col-8 pr-0">
          <MiscellaneousFeesDashboardContainer />
        </div>
      </div>
    </div>
  );
};

DashboardContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS}`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(DashboardContainer);
